module.exports = __webpack_public_path__ + "static/img/fazhan_01.3aec944.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/aboutPage/fazhan_01.jpg
// module id = K8hx
// module chunks = 14